var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/var/www/django/gbn.moscow/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/SellBlockInfo/SellBlockInfo.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
var macro_t_1 = runtime.makeMacro(
[], 
["block", "isNumber"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("block", Object.prototype.hasOwnProperty.call(kwargs, "block") ? kwargs["block"] : {});frame.set("isNumber", Object.prototype.hasOwnProperty.call(kwargs, "isNumber") ? kwargs["isNumber"] : runtime.contextOrFrameLookup(context, frame, "False"));var t_2 = "";t_2 += "\n    <div class=\"SellBlockInfo\">\n        <div class=\"SellBlockInfo-wrapper\">\n            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "block")),"title")) {
t_2 += "\n                <div class=\"SellBlockInfo-title\">\n                    ";
t_2 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "block")),"title"), env.opts.autoescape);
t_2 += "\n                </div>\n            ";
;
}
t_2 += "\n            <div class=\"SellBlockInfo-descr";
if(!runtime.contextOrFrameLookup(context, frame, "isNumber")) {
t_2 += " notNumber";
;
}
t_2 += "\">\n                ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "block")),"isSwitcher")) {
t_2 += "\n                    <div class=\"SellBlockInfo-descrSwitcher\">\n                        ";
frame = frame.push();
var t_5 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "block")),"switcher");
if(t_5) {t_5 = runtime.fromIterator(t_5);
var t_4 = t_5.length;
for(var t_3=0; t_3 < t_5.length; t_3++) {
var t_6 = t_5[t_3];
frame.set("item", t_6);
frame.set("loop.index", t_3 + 1);
frame.set("loop.index0", t_3);
frame.set("loop.revindex", t_4 - t_3);
frame.set("loop.revindex0", t_4 - t_3 - 1);
frame.set("loop.first", t_3 === 0);
frame.set("loop.last", t_3 === t_4 - 1);
frame.set("loop.length", t_4);
t_2 += "\n                            <label class=\"SellBlockInfo-descrSwitcherLabel";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0") == 0) {
t_2 += " SellBlockInfo-descrSwitcherLabel--checked";
;
}
t_2 += "\">";
t_2 += runtime.suppressValue(runtime.memberLookup((t_6),"title"), env.opts.autoescape);
t_2 += "\n                                <input class=\"SellBlockInfo-descrSwitcherInput\" type=\"radio\" name=\"radioType\" ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0") == 0) {
t_2 += "checked=\"checked\"";
;
}
t_2 += " value=";
t_2 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index"), env.opts.autoescape);
t_2 += ">\n                            </label>\n                        ";
;
}
}
frame = frame.pop();
t_2 += "\n                    </div>\n                ";
;
}
t_2 += "\n                <ul>\n\n                ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "block")),"isSwitcher")) {
t_2 += "\n                    ";
frame = frame.push();
var t_9 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "block")),"switcher");
if(t_9) {t_9 = runtime.fromIterator(t_9);
var t_8 = t_9.length;
for(var t_7=0; t_7 < t_9.length; t_7++) {
var t_10 = t_9[t_7];
frame.set("item", t_10);
frame.set("loop.index", t_7 + 1);
frame.set("loop.index0", t_7);
frame.set("loop.revindex", t_8 - t_7);
frame.set("loop.revindex0", t_8 - t_7 - 1);
frame.set("loop.first", t_7 === 0);
frame.set("loop.last", t_7 === t_8 - 1);
frame.set("loop.length", t_8);
t_2 += "\n                        <div class=\"SellBlockInfo-descrSwitcherSwitch";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0") == 0) {
t_2 += " SellBlockInfo-descrSwitcherSwitch--active";
;
}
t_2 += "\" data-switch=";
t_2 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index"), env.opts.autoescape);
t_2 += ">\n                            ";
frame = frame.push();
var t_13 = runtime.memberLookup((t_10),"items");
if(t_13) {t_13 = runtime.fromIterator(t_13);
var t_12 = t_13.length;
for(var t_11=0; t_11 < t_13.length; t_11++) {
var t_14 = t_13[t_11];
frame.set("text", t_14);
frame.set("loop.index", t_11 + 1);
frame.set("loop.index0", t_11);
frame.set("loop.revindex", t_12 - t_11);
frame.set("loop.revindex0", t_12 - t_11 - 1);
frame.set("loop.first", t_11 === 0);
frame.set("loop.last", t_11 === t_12 - 1);
frame.set("loop.length", t_12);
t_2 += "\n                                <p>\n                                    ";
if(runtime.contextOrFrameLookup(context, frame, "isNumber")) {
t_2 += "\n                                        <span>";
t_2 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index"), env.opts.autoescape);
t_2 += ".</span>\n                                    ";
;
}
t_2 += "\n                                    ";
t_2 += runtime.suppressValue(runtime.memberLookup((t_14),"text"), env.opts.autoescape);
t_2 += "\n                                </p>\n                            ";
;
}
}
frame = frame.pop();
t_2 += "\n                        </div>\n                    ";
;
}
}
frame = frame.pop();
t_2 += "\n                ";
;
}
else {
t_2 += "\n                    ";
frame = frame.push();
var t_17 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "block")),"items");
if(t_17) {t_17 = runtime.fromIterator(t_17);
var t_16 = t_17.length;
for(var t_15=0; t_15 < t_17.length; t_15++) {
var t_18 = t_17[t_15];
frame.set("item", t_18);
frame.set("loop.index", t_15 + 1);
frame.set("loop.index0", t_15);
frame.set("loop.revindex", t_16 - t_15);
frame.set("loop.revindex0", t_16 - t_15 - 1);
frame.set("loop.first", t_15 === 0);
frame.set("loop.last", t_15 === t_16 - 1);
frame.set("loop.length", t_16);
t_2 += "\n                        <p>\n                            ";
if(runtime.contextOrFrameLookup(context, frame, "isNumber")) {
t_2 += "\n                                <span>";
t_2 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index"), env.opts.autoescape);
t_2 += ".</span>\n                            ";
;
}
t_2 += "\n                            ";
t_2 += runtime.suppressValue(runtime.memberLookup((t_18),"text"), env.opts.autoescape);
t_2 += "\n                        </p>\n                    ";
;
}
}
frame = frame.pop();
t_2 += "\n                ";
;
}
t_2 += "\n\n                </ul>\n\n                ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "block")),"feedback")) {
t_2 += "\n                    <div class=\"SellBlockInfo-descrFeedback\">\n                        <div class=\"SellBlockInfo-descrFeedbackText\">\n                            ";
t_2 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "block")),"feedback")),"text"), env.opts.autoescape);
t_2 += "\n                        </div>\n                        <div class=\"SellBlockInfo-descrFeedbackInfo\">\n                            <div class=\"SellBlockInfo-descrFeedbackImg\">\n                                <img src=\"";
t_2 += runtime.suppressValue((lineno = 53, colno = 51, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "static"), "static", context, [runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "block")),"feedback")),"img")])), env.opts.autoescape);
t_2 += "\">\n                            </div>\n                            <div class=\"SellBlockInfo-descrFeedbackName\">\n                                ";
t_2 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "block")),"feedback")),"name"), env.opts.autoescape);
t_2 += "\n                            </div>\n                        </div>\n                    </div>\n                ";
;
}
t_2 += "\n            </div>\n        </div>\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_2);
});
context.addExport("SellBlockInfo");
context.setVariable("SellBlockInfo", macro_t_1);
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/SellBlockInfo/SellBlockInfo.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/SellBlockInfo/SellBlockInfo.jinja
// module id = 32
// module chunks = 0